export const INTENTION_TYPE = {
  REBOOK: 'rebook',
  UPGRADE: 'upgrade'
};
